@if (stateAbbrev() && tabs().length) {
  <section #moduleTop class="internal-links" aria-labelledby="internal-links-heading">
    <div class="inner">

      @if (isStatePage()) {
        <p class="popular-badge">
          <span class="badge-dot" aria-hidden="true"></span>
          Popular in your state
        </p>
      } @else {
        <div class="mode-toggle" role="group" aria-label="Show filters by city or by state">
          <button
            type="button"
            class="toggle-option"
            [class.active]="mode() === linkMode.CITY"
            [attr.aria-pressed]="mode() === linkMode.CITY"
            (click)="setMode(linkMode.CITY)"
          >
            By City
          </button>
          <button
            type="button"
            class="toggle-option"
            [class.active]="mode() === linkMode.STATE"
            [attr.aria-pressed]="mode() === linkMode.STATE"
            (click)="setMode(linkMode.STATE)"
          >
            By State
          </button>
        </div>
      }

      <h2 id="internal-links-heading" class="heading">
        {{ heading().prefix }} <em>{{ heading().location }}</em>
      </h2>
      <p class="subheading">{{ subheading() }}</p>

      <div class="tabs" role="tablist" aria-label="Browse therapist filters">
        @for (tab of tabs(); track tab.key; let i = $index) {
          <button
            #tabButton
            type="button"
            role="tab"
            class="tab"
            [class.active]="tab.key === activeTab()?.key"
            [attr.aria-selected]="tab.key === activeTab()?.key"
            [attr.tabindex]="tab.key === activeTab()?.key ? 0 : -1"
            [attr.id]="'tab-' + tab.key"
            [attr.aria-controls]="'panel-' + tab.key"
            (click)="selectTab(tab.key)"
            (keydown)="onTabKeydown($event, i)"
          >
            {{ tab.label }}
            <span class="count">{{ tab.links.length }}</span>
          </button>
        }
      </div>

      @for (tab of tabs(); track tab.key) {
        <div
          class="panel"
          role="tabpanel"
          [attr.id]="'panel-' + tab.key"
          [attr.aria-labelledby]="'tab-' + tab.key"
          [hidden]="tab.key !== activeTab()?.key"
        >
          <h3 class="panel-heading">{{ tab.sectionHeading }}</h3>

          <ul class="link-grid" [class.expanded]="showAll()">
            @for (link of tab.links; track link.url) {
              <li class="grid-item">
                <a class="link-card" [href]="link.url">
                  <span class="card-label">{{ link.label }}</span>
                  <iris-icon
                    class="card-icon"
                    name="arrow_line_right"
                    [size]="iconSizes.MD"
                    aria-hidden="true"
                  ></iris-icon>
                </a>
              </li>
            }
          </ul>

          @if (tab.links.length > mobileVisibleCount) {
            <button
              type="button"
              class="see-more"
              [attr.aria-expanded]="showAll()"
              (click)="toggleShowAll(moduleTop)"
            >
              {{ showAll() ? 'See less' : 'See more' }}
              <iris-icon
                class="see-more-icon"
                name="expand_more"
                [class.open]="showAll()"
                [size]="iconSizes.SM"
                aria-hidden="true"
              ></iris-icon>
            </button>
          }
        </div>
      }
    </div>
  </section>
}
